import { createElement, forwardRef } from 'react';
import { cq } from '../patterns/cq.js';
import { splitProps } from '../helpers.js';
import { styled } from './factory.js';

export const Cq = /* @__PURE__ */ forwardRef(function Cq(props, ref) {
  const [patternProps, restProps] = splitProps(props, cq.propKeys)
  const styleProps = cq.raw(patternProps)
  const mergedProps = { ref, ...styleProps, ...restProps }
  return createElement(styled["div"], mergedProps)
})